import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {MoreLikeThisItemService} from './moreLikeThisItem.service';
import {PrimoResponse} from "../../../infra/dataStructures/PrimoResponses/doc.interfcae";

const get = require('lodash/get');

@Component({
    selector: 'prm-more-like-this-item',
    templateUrl: 'components/search/moreLikeThis/moreLikeThisItem/more-like-this-item.html',
})

export class PrmMoreLikeThisItem implements OnInit {
    @Input() private moreLikeThisItem: any;
    private renderFlag: boolean = true;
    private tooltipDelay;
    @Input() private moreInTheSameCourseItem: any;
    @Input() private item: [PrimoResponse.IDoc];

    constructor(private moreLikeThisItemService: MoreLikeThisItemService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService) {
    }

    ngOnInit() {
        this.$scope.$watch(() => this.moreInTheSameCourseItem, () => { //this is done in order to re render the thumbnail directive when the virtual browse item changes
            this.renderFlag = false;
            this.$timeout(() => {
                this.renderFlag = true
            }, 0);
            this.tooltipDelay = '500';
        })
    }

    private moreOfTheSameItemTitle() {
        return get(this.moreInTheSameCourseItem, 'pnx.display.title[0]');
    }
    
    private moreOfTheSameItemVerTitle() {
        return get(this.moreInTheSameCourseItem, 'pnx.display.vertitle[0]');
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/moreLikeThis/moreLikeThisItem/moreLikeThisItem.directive.ts